import { ContractInput } from '../context/types';

export interface InputSummary {
  client: string;
  merchantCount: number;
  locationCount: number;
  practitionerCount: number;
  practitionersWithoutNpi: number;
  catACount: number;
  catBCount: number;
  catCExcludedCount: number;
  effectiveStart: string;
  effectiveEnd: string;
  rateLine: string | null;
  taxId: string;
  groupNpi2: string;
}

const formatRate = (rateInDollars: number): string =>
  `$${rateInDollars.toFixed(2)}/case`;

export const summarizeInput = (input: ContractInput): InputSummary => {
  const practitionerCount = input.locations.reduce(
    (sum, l) => sum + l.practitioners.length,
    0,
  );
  const practitionersWithoutNpi = input.locations.reduce(
    (sum, l) => sum + l.practitioners.filter(p => p.npi == null).length,
    0,
  );
  return {
    client: input.client_name,
    merchantCount: 1,
    locationCount: input.locations.length,
    practitionerCount,
    practitionersWithoutNpi,
    catACount: input.fee_schedule.codes.category_a.length,
    catBCount: input.fee_schedule.codes.category_b.length,
    catCExcludedCount: input.fee_schedule.codes.category_c_excluded.length,
    effectiveStart: input.contract_details.effective_date,
    effectiveEnd: input.contract_details.term_end,
    rateLine:
      input.fee_schedule.rate_per_case != null
        ? formatRate(input.fee_schedule.rate_per_case)
        : null,
    // PR 1 enforces a single tax_id across all locations, so locations[0] is
    // the canonical merchant-level TIN. PR 2 fans this out per Contract.
    taxId: input.locations[0]?.tax_id ?? '',
    groupNpi2: input.locations[0]?.group_npi_type2 ?? '',
  };
};
